module.exports = __webpack_public_path__ + "img/image6.7d120a80.jpg";